import { Drawer } from "@/base/components/index";
import { useModalHeaderMenuStyles } from "./modal-header-menu.styles";
import { useContextPageRoot } from "../../context/root-context";
import { renderMenuItems } from "../../utils/render-menu-items";
import { Menu } from "@/base/index";
import { useMenu } from "@/app/hook/use-menu";

export const ModalHeaderMenu = () => {
  const { styles } = useModalHeaderMenuStyles();
  const { isOpenModalMenu, fetchCloseHeaderMenu } = useContextPageRoot();
  const menuItems = useMenu("main");

  return (
    <Drawer
      placement="left"
      open={isOpenModalMenu}
      onClose={fetchCloseHeaderMenu}
      className={styles.drawer}
    >
      <Menu
        theme="light"
        mode="inline"
        selectable={false}
        onClick={fetchCloseHeaderMenu}
        items={renderMenuItems(menuItems || [])}
      />
    </Drawer>
  );
};
